import React from 'react';
import {render} from 'react-dom';
import { Provider } from "react-redux";
import {registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import './index.css';
import 'filepond/dist/filepond.min.css';
import './js/firebase/firebase-manager'
import App from './App';
import store from './js/store/index'
import registerServiceWorker from './registerServiceWorker';

registerPlugin(FilePondPluginFileValidateType)

render(
    <Provider store={store}>
        <App />
    </Provider>, 
    document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js